import { render, staticRenderFns } from "./repassword.vue?vue&type=template&id=47c2e2b0&scoped=true&"
import script from "./repassword.vue?vue&type=script&lang=js&"
export * from "./repassword.vue?vue&type=script&lang=js&"
import style0 from "./repassword.vue?vue&type=style&index=0&id=47c2e2b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2e2b0",
  null
  
)

export default component.exports